import {Module, AjaxP} from '@changke/staticnext-lib';
import {i18n} from '../../js/services/i18n';
import type {IMessage} from '../../js/base/types';
import csrf from '../../js/services/csrf';

export default class LeaveMessage extends Module {
  /**
   * Initialize from DOM node
   * @param {Element} root Root element
   * @return {LeaveMessage}
   */
  static attachTo(root: Element): LeaveMessage {
    return new LeaveMessage(root);
  }

  messageForm_: HTMLFormElement | null;
  spinner_: Element | null;
  human_: boolean;

  constructor(root: Element) {
    super(root);
    this.name_ = 'leavemessage';
    this.messageForm_ = null;
    this.spinner_ = null;
    this.human_ = false;
  }

  /**
   * Start module
   */
  start(): void {
    const msgTextArea: HTMLTextAreaElement = this.root_.querySelector('[name="content"]')!;
    if (msgTextArea) {
      msgTextArea.addEventListener('focus', () => {
        this.human_ = true;
      });
    }

    this.messageForm_ = this.root_.querySelector('[name="messageform"]');
    if (this.messageForm_) {
      this.messageForm_.addEventListener('submit', ev => {
        ev.preventDefault();
        this.showSpinner(true);
        const form = this.messageForm_!;
        const fd = new FormData(form);
        const fdExt: Record<string, string> = {};
        const messageData: IMessage = {
          title: ''
        };
        for (const [n, v] of fd) {
          if (typeof v === 'string') {
            if (v.length > 0) {
              fdExt[n] = v; // ignore empty fields e.g. email
            }
          }
        }
        if (fdExt.username) {
          messageData.username = fdExt.username;
        }
        messageData.title = fdExt.title;
        if (fdExt.content) {
          messageData.content = fdExt.content;
        }
        if (fdExt.email) {
          messageData.email = fdExt.email;
        }
        if (this.human_) {
          messageData.human = '1';
        }
        AjaxP.postJSON<IMessage, null>(form.action, messageData, csrf.getTokenHeader()).then(() => {
          form.reset();
          this.showSpinner(false);
          this.publish('snackbar:show', {text: i18n.getText('blog', 'promptMessageSent', '悄悄话已送达')});
        }).catch(err => {
          window.alert(err);
        });
      });
    }

    this.spinner_ = this.root_.querySelector('[data-role="spinner"]');
  }

  /**
   * Show ajax spinner
   *
   * @param {boolean} show
   */
  showSpinner(show: boolean): void {
    if (this.spinner_) {
      const method = show ? 'add' : 'remove';
      this.spinner_.classList[method]('show');
    }
  }
}
